<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Employee Separations"
      text="Edit Employee Separations"
      class="mb-0"
    > 
      <form>
        <v-container v-if="dialog">
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="reason"
                v-validate="'required|max:5000'"
                :rows="5"
                :error-messages="errors.collect('reason')"
                data-vv-name="reason"        
                label="Reason"
              />
            </v-col>          
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      employeeUid: {
        type: String, 
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
        loading: false,
        dialog: false,
        reason: '',
        description: '',
        separationId: null,
      }
    },
    methods: {      
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.employeeSeparations().update(this.employeeUid, this.separationId, this.prepareFormData())
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      toggleDialog (separation) {
        this.reason = separation.reason
        this.separationId = separation.id

        this.dialog = true
      },
      prepareFormData () {
        return {
          reason: this.reason,
        }
      },
    },
  }
</script>
